import type { UIEvent } from 'react';

import type { Cart, Checkout, User } from 'core';

export enum SUMMARY_COMPONENTS_CONST {
  ADDRESS_TEST_ID = 'address',
  CTA_TEST_ID = 'button-cta',
  ITEMS_TEST_ID = 'items',
  ITEM_TEST_ID = 'item',
  LOADER_TEST_ID = 'container',
  PAYMENT_TEST_ID = 'payment',
  POINTS_TEST_ID = 'points',
  REWARDS_TEST_ID = 'rewards',
  VALUES_TEST_ID = 'values',
}

type SummaryItem = Omit<
  Cart['data']['items'][number],
  | 'description'
  | 'isAvailable'
  | 'isCustomCombo'
  | 'priceNum'
  | 'priceTotalNum'
  | 'inventory'
  | 'previousQuantity'
  | 'productPosition'
>;

type Payment = Checkout['paymentMethods']['data']['bankSlip']['paymentInfo'][number]['name'];

type BankSlip = Pick<
  Checkout['paymentMethods']['data']['bankSlip']['paymentInfo'][number],
  'administrateTax' | 'name' | 'paymentPlanType'
>;

type Values = Pick<
  Cart['data'],
  | 'cashback'
  | 'cashbackNum'
  | 'totalDiscount'
  | 'totalDiscountNum'
  | 'shipping'
  | 'total'
  | 'subTotal'
  | 'paymentPlanType'
> &
  BankSlip;

export type ButtonCtaProps = {
  onClick: (event: UIEvent<HTMLButtonElement>) => void;
  label: string;
};

export type SummaryItemProps = {
  items: SummaryItem[];
};

export type PaymentProps = {
  description: Payment;
  changePaymentMethod: (event: UIEvent<HTMLButtonElement>) => void;
};

export type AddressProps = {
  businessModelCode: Cart['current']['shippingModel']['businessModelCode'];
  distributionCenterAddress: Cart['current']['distributionCenterAddress'];
  fullAddress: User['data']['fullAddress'];
  isWithdrawal?: boolean;
};

export type AddressMapper = {
  [K in AddressProps['businessModelCode']]: ElementType<HTMLButtonElement>;
};

export type ValuesProps = Widget<Values> & {
  bankSlipEmission?: boolean;
  cashbackInfo?: string;
  dataMargin?: string;
  values: Values;
};

export type RewardsProps = {
  rewards: Checkout['rewards']['data'];
};

export type ItemsPointsProgramProps = {
  items: Cart['data']['pointsPrograms'];
};
